//React
import React, { useEffect, useState } from "react";
//Components
import {
  Button,
  Dropdown,
  FlexBox,
  Image,
  Input,
  Modal,
  Screen,
  TranslatedString,
  Code,
} from "components";
//Paths
import ROUTE_PATH from "Routes/paths";
//Styles
import "./styles.scss";
//Libraries
import cx from "classnames";
import ResizePanel from "react-resize-panel-ts";
//Assets
import Logo from "assets/logo.svg";
import { ChangeHistory, copyText } from "utils";
let code = `<!-- Create a "WhatsApp Login" button -->
<div id="otpless">
<script type="text/javascript" src="https://otpless.com/auth.js"></script>
<!-- Get user's whatsapp number and name -->
<script type="text/javascript">
  function otpless() {
    var userDetails = otplessUser;
    var waName = userDetails.waName;
    var waNumber = userDetails.waNumber;
    // Signup/signin the user and redirect to next page
  }
</script>
</div>`;
const Landing = () => {
  const [copyButtonText, setCopyButtonText] = useState("Copy Code");

  //Return UI
  return (
    <Screen
      className="new-docs-screen"
      hasHeader
      screenAnimationClass="no-animation"
      customHeaderDetails={
        <Button
          variant="outline"
          className="fs-10 pd-5 w-30"
          text="Platforms"
          onClick={() => {
            ChangeHistory("back", ROUTE_PATH.PLATFORM.HOME);
          }}
        />
      }
    >
      <div className="h-100 w-100">
        <FlexBox
          justifyAround
          alignCenter
          flexColumn
          className="middle-section text-center pd-20"
        >
          <p className="fs-22 font-medium text-left">
            <span className="clr-theme">Copy-paste</span> this code on your
            login page
          </p>
        </FlexBox>
        <FlexBox
          justifyBetween
          flexColumn
          className="bottom-section clr-white pd-20"
        >
          <div className="h-85p w-100">
            <Code code={code} language="html" />
          </div>
          <FlexBox alignEnd className="h-15p w-100">
            <Button
              text={copyButtonText}
              className="w-100 fs-14"
              onClick={() => {
                copyText(code);
                setCopyButtonText("Copied");
                setTimeout(() => {
                  setCopyButtonText("Copy Code");
                }, 2000);
              }}
            />
          </FlexBox>
        </FlexBox>
        {/* <ResizePanel direction="n" containerClass="bottom-fixed-section">
          <FlexBox justifyBetween flexColumn className="clr-white pd-20">
            <div className="h-75p w-100">
              <Code
                code={`
<!-- Create a " WhatsApp Login " button -->
 <div id="otpless">
  <script type="text/javascript" src="https://otpless.com/auth.js"></script>
  <!-- Get user's whatsapp number and name -->
  <script type="text/javascript">
    function otpless() {
      var userDetails = otplessUser;
      // Signup-sign the user and redirect to next page
    }
  </script>
</div>`}
              />
            </div>
            <FlexBox alignEnd className="h-15p w-100">
              <Button text="Copy code" className="w-100" />
            </FlexBox>
          </FlexBox>
        </ResizePanel> */}
      </div>
    </Screen>
  );
};

export default Landing;
